import * as React from "react";
import {UserAchievementInfo} from "../../../generated/protocol";

interface Props {
    info: UserAchievementInfo;
}

export class UserLevel extends React.Component<Props, {}> {


    getXp() {
        return (100 * ((this.props.info.experience.xp - this.props.info.experience.thisLevelXp) / (this.props.info.experience.nextLevelXp - this.props.info.experience.thisLevelXp))) + "%";
    }

    render() {
        if (!this.props.info || !this.props.info.experience) {
            return <div/>;
        }
        return (
            <div className="col-sm-12">
                <div className="ibox">
                    <div className="ibox-content">
                        <h2>LEVEL: {this.props.info.experience.level}</h2>

                        <div className="progress ng-isolate-scope" value="2">
                            <div className="progress-bar" role="progressbar" aria-valuenow="15" aria-valuemin="0"
                                 aria-valuemax="100" aria-valuetext="90%" style={{width: this.getXp()}}></div>
                        </div>

                        <p className="small">
                            <span><i className="fa fa-circle text-navy" style={{color: "darkgrey"}}></i> <span
                                className="font-bold">Online status: </span> n/a</span>
                        </p>

                    </div>
                </div>
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/app/ui/user/UserLevel.tsx